module.exports = __webpack_public_path__ + "img/fa23940.jpg";